module.exports = __webpack_public_path__ + "static/media/icon-whatsapp.9e8d8c4b.svg";